import styled from 'styled-components';
import MUIFab from '@mui/material/Fab';
import TableCell from '@mui/material/TableCell';
import { GroupsContainer } from 'shared/components/styled';
import ButtonMui from '@mui/material/Button';
import AutocompleteMui from '@mui/lab/Autocomplete';
import { RowGrid } from 'shared/components/VirtualizedView';
import PopperMui from '@mui/material/Popper';

export const Fab = styled(MUIFab)`
  position: fixed !important;
  right: 5%;
  bottom: 5%;
  z-index: 100;
`;

export const Header = styled.div`
  background-color: #EAF0F6;
  width: 100%;
  padding: 10px 20px;
  color: #48596B;
  h2 {
    font-size: 32px;
    font-weight: normal;
  }
  b {
    font-size: 24px;
    font-weight: bold;
    padding: 0 10px;
    color: #778BA5;
  }
  img {
    height: 60px;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Container = styled.div`
  label {
    font-size: 16px;
    font-weight: bold;
    color: #595959;
  }
  input, textarea {
    background-color: white;
  }
`;

export const Body = styled.div`
  width: 100%;
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  justify-content: center;  
`;

export const Row = styled.div`
  display: flex;
  align-items: stretch;
`;

export const ColumnHeader = styled(TableCell)`
  color: 595959 #48596B !important;
  font-size: 16px;
  height: 22px;
  ${({ active }) => active && 'font-weight: bold;'}
`;

export const GridContainer = styled(GroupsContainer)`
`;

export const Button = styled(ButtonMui)`
  text-transform: none !important;
  .MuiButton-label {
    font-weight: bold !important
    font-size: 16px !important;
  }
`;

export const ButtonBar = styled.div`
  padding: 0 20px;
  height: 48px;
`;

export const OutlinedButton = styled(Button).attrs({
  variant: 'outlined',
})`
`;

export const Autocomplete = styled(AutocompleteMui)`
  width: 270px;
  height: 48px;

  .MuiOutlinedInput-root {
    background-color: #Fff !important;
    height: 48px;
    padding: 8px !important;
  }
  .MuiAutocomplete-clearIndicator {
    display: none;
  }
  .MuiAutocomplete-popper {
    width: 400px;
  }
`;

export const UserRow = styled(RowGrid)`
  height: 64px !important;
  .show-on-hover {
    opacity: 0;
    transition: opacity 200ms ease-out;
  }
  &:hover .show-on-hover {
    opacity: 1 !important;
  }

  .MuiCheckbox-root {
    color: #CBD6E2 !important;
  }
  .MuiCheckbox-root.Mui-checked {
    color: #F89915 !important;
  }

`;

export const SvgIcon = styled.img.attrs(({ name }) => ({
  src: `/images/svg/${name}.svg`,
}))``;

export const Popper = styled(PopperMui).attrs({
  placement: 'bottom-end',
})`
  width: fit-content !important;
`;

export const Scroller = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 20px;
  padding-bottom: 60px;
  ::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
  }
`;